module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cpo-event",
    class: _vm.rootClasses
  }, [_c('div', {
    staticClass: "cpo-event--root"
  }, [_c('div', {
    staticClass: "cpo-event--branch cpo-event--branch__label"
  }, [_c('div', {
    staticClass: "cpo-event--label"
  }, [_c('div', {
    staticClass: "cpo-event--label-text",
    domProps: {
      "textContent": _vm._s(_vm.content.title)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "cpo-event--trunk"
  }, [_c('div', {
    staticClass: "cpo-event--bubble"
  }, [(_vm.facet === 'end') ? _c('cmp-icon', {
    staticClass: "cpo-event--icon cpo-event--icon__small",
    attrs: {
      "symbol": "party",
      "size": "medium"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.facet === 'end') ? _c('cmp-icon', {
    staticClass: "cpo-event--icon cpo-event--icon__large",
    attrs: {
      "symbol": "party",
      "size": "x-large"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "cpo-event--branch cpo-event--branch__content"
  }, [_c('div', {
    staticClass: "cpo-event--label-text cpo-event--label-text__mobile",
    domProps: {
      "textContent": _vm._s(_vm.content.title)
    }
  }), _vm._v(" "), _c('cmp-accordion', {
    attrs: {
      "facet": "cpo-event",
      "is-active": _vm.accordionState,
      "passive-mode": true
    },
    on: {
      "request-change": function($event) {
        _vm.updateState($event)
      }
    },
    scopedSlots: _vm._u([{
      key: "head",
      fn: function(props) {
        return _vm.content.next_starts && _vm.content.next_starts.length > 3 ? [_c('button', {
          staticClass: "cpo-event--accordion-head",
          class: _vm.accordionHeadClasses(props.isActive)
        }, [_vm._v("\n                        " + _vm._s(_vm.content.toggle_text) + "\n                        "), _c('cmp-icon', {
          staticClass: "cpo-event--accordion-head-icon",
          attrs: {
            "symbol": "chevron_down",
            "size": "x-small"
          }
        })], 1)] : undefined
      }
    }, {
      key: "body",
      fn: function(props) {
        return [_c('ul', {
          staticClass: "u-reset cpo-event--plugins"
        }, _vm._l((_vm.content.next_starts), function(startdate) {
          return _c('li', {
            staticClass: "cpo-event--plugin cpo-event--date",
            domProps: {
              "innerHTML": _vm._s(startdate)
            }
          })
        }))]
      }
    }])
  }), _vm._v(" "), _c('ul', {
    staticClass: "u-reset cpo-event--plugins"
  }, [(_vm.content.date) ? _c('li', {
    staticClass: "cpo-event--plugin cpo-event--date",
    domProps: {
      "innerHTML": _vm._s(_vm.content.date)
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.plugins), function(plugin) {
    return _c('li', {
      staticClass: "cpo-event--plugin"
    }, [_c(plugin.type, {
      tag: "component",
      attrs: {
        "plugin": plugin,
        "facet": _vm.facet
      }
    })], 1)
  })], 2)], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-26a0fb0d", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26a0fb0d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sib-website/assets/src/js/app/vue/components/cms-plugins/course-progress/cpo-event/index.vue
// module id = 517
// module chunks = 7